import $, {contains} from 'jquery';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Route, HashRouter as Router, Switch} from 'react-router-dom';
import CookieConsent from './components/CookieConsent';
import Sidebar from './components/layouts/Sidebar';
import CookiesContainer from './containers/CookiesContainer';
import HelpContainer from './containers/HelpContainer';
import Login from './containers/LoginContainer';
import StartContainer from './containers/StartContainer';
import VersionContainer from './containers/VersionContainer';
import AccountService from './services/AccountService';
import AuthService from './services/AuthService';
import InternalUserService from './services/InternalUserService';
import withAuth from './utils/withAuth';
import InternalUserListContainer from './containers/InternalUserListContainer';
import InternalUserContainer from './containers/InternalUserContainer';
import SubcontratorListContainer from './containers/SubcontratorListContainer';
import ApplicationSettingsListContainer from './containers/ApplicationSettingsListContainer';
import ProjectCategoryListContainer from './containers/ProjectCategoryListContainer';
import ToolsListContainer from './containers/ToolsListContainer';
import ActivityListContainer from './containers/ActivityListContainer';
import CarListContainer from './containers/CarListContainer';
import EmployeeListContainer from './containers/employee/EmployeeListContainer';
import EmployeeContainer from './containers/employee/EmployeeContainer';
import ConfirmPasswordContainer from './containers/auth/ConfirmPasswordContainer';
import RemindPasswordContainer from './containers/auth/RemindPasswordContainer';
import ChangePasswordContainer from './containers/auth/ChangePasswordContainer';
import ClientListContainer from './containers/client/ClientListContainer';
import ProjectListContainer from './containers/project/ProjectListContainer';
import HourlyReportListContainer from './containers/HourlyReportListContainer';
import ToolListContainer from './containers/ToolListContainer';
import ProjectDetailsContainer from './containers/ProjectDetailsContainer';
import ToolsDetailsContainer from './containers/ToolsDetailsContainer';
import DriverRateListContainer from './containers/DriverRateListContainer';
import ClientContainer from './containers/client/ClientContainer';
import ProfileContainer from './containers/profile/ProfileContainer';
import ReportedDayListContainer from './containers/ReportedDayListContainer';
import ReportedDayDetailsContainer from './containers/ReportedDayDetailsContainer';
import PayReportListContainer from './containers/PayReportListContainer';
import LogEntryListContainer from './containers/LogEntryListContainer';
import ProjectCumulativeReportListContainer from './containers/ProjectCumulativeReportListContainer';
import ToolDetailsContainer from './containers/ToolDetailsContainer';
import EmailListContainer from './containers/EmailListContainer';
import EmailEditContainer from './containers/EmailDetailsContainer';
import ProjectSettleReportListContainer from './containers/ProjectSettleReportListContainer';
import DocumentTypeListContainer from './containers/DocumentTypeListContainer';
import EmployeeAbsenceReasonList from './containers/employee/EmployeeAbsenceReasonList';
import UserCategoryListContainer from './containers/UserCategoryListContainer.js';
import ManagerTimelineContainer from './containers/ManagerTimelineContainer';
import ReserveContainer from './containers/reserve/ReserveContainer';
import ProjectDashboardContainer from './containers/project/ProjectDashboardContainer';
import ProjectDashboardFullScreenContainer from './containers/project/ProjectDashboardFullScreenContainer';
import CountryListContainer from './containers/CountryListContainer';
import ExternalSupervisorList from './containers/ExternalSupervisorList';
import AfterHoursDriveAlarmListContainer from './containers/AfterHoursDriveListContainer';
import UpdateAppDialog from './containers/UpdateAppDialog.js';
import AccommodationListContainer from './containers/accommodation/AccommodationListContainer';
import AccommodationContainer from './containers/accommodation/AccommodationContainer';
import AccommodationTimelineContainer from './containers/accommodation/AccommodationTimelineContainer';
import EmployeeAccommodationTimelineContainer from './containers/accommodation/EmployeeAccommodationTimelineContainer';
import AccommodationCategoryContainer from './containers/accommodation/AccommodationCategoryContainer';
import AccommodationDashboardContainer from './containers/accommodation/AccommodationDashboardContainer';
import DayViewContainer from './containers/userReport/DayViewContainer.js';
import WeekViewContainer from './containers/userReport/WeekViewContainer.js';
import MonthViewContainer from './containers/userReport/MonthViewContainer.js';
import AcommodationDashboardFullScreenContainer from './containers/accommodation/AcommodationDashboardFullScreenContainer';
import Constants from './utils/constants.js';
import UserDayDetailsContainer from './containers/UserDayDetailsContainer.js';
import UserDayCreateContainer from './containers/UserDayCreateContainer.js';
import UsersListContainer from './containers/UsersListContainer.js';
import UserDetailsContainer from './containers/UserDetailsContainer.js';
import LeaveRequestContainer from './containers/employee/LeaveRequestContainer.js';
import LeaveRequestListContainer from './containers/employee/LeaveRequestListContainer.js';
import LeaveRequestViewContainer from './containers/employee/LeaveRequestViewContainer.js';
import DashboardContainer from './containers/dashboard/DashboardContainer.js';
import DelegationTabContainer from './containers/delegation/DelegationTabContainer.js';
import DelegationContainer from './containers/delegation/DelegationContainer.js';
import DelegationListContainer from './containers/delegation/DelegationListContainer.js';
import PublicHolidaysCalendarComponent from './containers/PublicHolidaysCalendarComponent.js';
import PayrollEntryListContainer from './containers/PayrollEntryListContainer.js';
import ProjectDailyOverviewListContainer from './containers/ProjectDailyOverviewListContainer.js';


class App extends Component {
    constructor() {
        super();
        this.authService = new AuthService();
        this.internalUserService = new InternalUserService();
        this.accountService = new AccountService();
        this.state = {
            user: this.authService.getProfile(),
            collapsed: false,
            toggled: false,
            renderSidebar: true,
            appInfo: {
                version: process.env.REACT_APP_VERSION,
                buildNumber: process.env.REACT_APP_BUILD_NUMBER,
                lastVersionReleaseNote: process.env.REACT_APP_LAST_VERSION_RELEASE_NOTE,
            },
            updateAppDialogVisible: false
        };
        this.handleLogoutUser = this.handleLogoutUser.bind(this);
        this.handleHideMenu = this.handleHideMenu.bind(this);
        this.handleShowMenu = this.handleShowMenu.bind(this);
        this.setActiveMenu = this.setActiveMenu.bind(this);
        this.handlePreLogoutUser = this.handlePreLogoutUser.bind(this);
        this.updateApp = this.updateApp.bind(this);
    }

    componentDidMount() {
        if (this.authService.getFromSessionToken('id_token') === null) {
            this.authService.setFromLocalStorageToSessionStorageToken();
        }
        window.addEventListener('beforeunload', function (event) {
            localStorage.removeItem('id_token');
        });
    }


    setActiveMenu(activeUrl) {
        if (activeUrl !== this.state.activeUrl) {
            this.setState({activeUrl});
        }
    }

    updateApp(oldVersion, newVersion) {
        if (this.state.updateAppDialogVisible !== true) {
            this.setState({updateAppDialogVisible: true, appOldVersion: oldVersion, appNewVersion: newVersion});
        }
    }

    handleHideMenu() {
        if (!!this.state.renderSidebar) {
            this.setState({renderSidebar: false});
        }
    }

    handleShowMenu() {
        if (!this.state.renderSidebar) {
            this.setState({renderSidebar: true});
        }
    }

    handleToggleSidebar() {
        this.setState((prevState) => ({toggled: !prevState.toggled}));
    }

    handleCollapsedChange() {
        this.setState(
            (prevState) => ({collapsed: !prevState.collapsed}),
            () => {
                if (this.state.collapsed) {
                    $('.pro-sidebar-inner').css('position', 'relative');
                } else {
                    $('.pro-sidebar-inner').css('position', 'fixed');
                }
            }
        );
    }

    handlePreLogoutUser(callBack) {
        this.authService.logout();
        if (this.state.user !== null) {
            this.setState({user: null}, () => this.afterPreLogoutUser());
            this.setState({user: null}, () => {
                if (callBack) callBack();
            });
        } else {
            if (callBack) callBack();
        }
    }

    handleLogoutUser(url) {
        this.authService.logout();
        if (!!url && typeof url === 'string') {
            window.location.href = '/#login?location=' + url;
        } else {
            window.location.href = '/#/login?force=true';
        }
        if (this.state.user) {
            this.setState({user: null});
        }
    }

    

    

    render() {
        const authService = this.authService;
        return (
            <React.Fragment>

                <UpdateAppDialog 
                    visible={this.state.updateAppDialogVisible} 
                    handleClose={() => {
                        this.setState({updateAppDialogVisible: false});
                    }}
                    oldVersion={this.state.appOldVersion}
                    newVersion={this.state.appNewVersion}
                />
                <CookieConsent
                    location='bottom'
                    buttonText='Akceptuję'
                    cookieName='cookiePolicy'
                    style={{background: 'rgba(0, 0, 0, 0.8)'}}
                    buttonStyle={{
                        background: '#1c3275',
                        color: 'white',
                        fontSize: '16px',
                        fontFamily: 'Ubuntu',
                        fontWeight: 500,
                        borderRadius: '3px',
                    }}
                    expires={150}
                >
                    Nasz serwis wykorzystuje pliki cookies. Możesz zrezygnować ze zbierania informacji poprzez pliki cookies, zmieniając
                    ustawienia Twojej przeglądarki - w takim przypadku nie gwarantujemy poprawnego działania serwisu.
                </CookieConsent>
                <Router>
                    <div className={!authService.loggedIn() && !!this.state.renderSidebar ? 'app' : 'app logged'}>
                        {!!authService.loggedIn() && !!this.state.renderSidebar ? (
                            <div>
                                <div className='sidebar-vertical'>
                                    <Sidebar
                                        collapsed={this.state.collapsed}
                                        toggled={this.state.toggled}
                                        loggedUser={this.state.user}
                                        handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                        handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                        handleLogoutUser={this.handleLogoutUser.bind(this)}
                                        authService={this.authService}
                                        accountService={this.accountService}
                                        submenu={undefined}
                                        activeUrl={this.state.activeUrl}
                                    />
                                </div>

                                <div className='sidebar-horizontal'>
                                    <Sidebar
                                        collapsed={this.state.collapsed}
                                        toggled={this.state.toggled}
                                        loggedUser={this.state.user}
                                        handleToggleSidebar={this.handleToggleSidebar.bind(this)}
                                        handleCollapsedChange={this.handleCollapsedChange.bind(this)}
                                        handleLogoutUser={this.handleLogoutUser.bind(this)}
                                        authService={this.authService}
                                        accountService={this.accountService}
                                        userService={this.internalUserService}
                                        submenu={true}
                                        activeUrl={this.state.activeUrl}
                                    />
                                </div>
                            </div>
                        ) : null}
                        <main id='main-container'>
                            {/* <div className={`${authService.loggedIn() ? 'container-fluid' : ''}`}> */}
                            <Switch>
                                <Route
                                    exact
                                    path='/'
                                    render={(props) => (
                                        <Login
                                            {...props}
                                            onAfterLogin={() => {
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                        />
                                    )}
                                />
                                <Route
                                    path='/login'
                                    render={(props) => (
                                        <Login
                                            {...props}
                                            onAfterLogin={() => {
                                                this.setState({user: this.authService.getProfile().sub});
                                            }}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/forgot-password'
                                    component={(prp) => (
                                        <RemindPasswordContainer
                                            {...prp}
                                            onAfterLogin={() => {
                                                this.setState({
                                                    user: this.authService.getProfile().sub,
                                                });
                                            }}
                                            type='REMIND'
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/set-password'
                                    component={(prp) => (
                                        <ChangePasswordContainer
                                            {...prp}
                                            onAfterLogin={() => {
                                                this.setState({
                                                    user: this.authService.getProfile().sub,
                                                });
                                            }}
                                            handlePreLogoutUser={this.handlePreLogoutUser}
                                            type='RECOVER'
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/user-register'
                                    component={(prp) => (
                                        <ConfirmPasswordContainer
                                            {...prp}
                                            onAfterLogin={() => {
                                                this.setState({
                                                    user: this.authService.getProfile().sub,
                                                });
                                            }}
                                            handlePreLogoutUser={this.handlePreLogoutUser}
                                            type='CREATE'
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/start'
                                    component={withAuth(
                                        StartContainer,
                                        'VIEW',
                                        ['ROLE_MANAGE_OWN_PROFILE'],
                                        this.handleLogoutUser,
                                        undefined,
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'start'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/user-list'
                                    component={withAuth(
                                       this.authService.getProfile().usersViewMode === 'SEPARATE' ? InternalUserListContainer : UsersListContainer,
                                        'VIEW',
                                        ['ROLE_USER_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        this.authService.getProfile().usersViewMode === 'SEPARATE' ? 'internaluser.listName' :'usersListName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'user'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/profile'
                                    component={withAuth(
                                        ProfileContainer,
                                        'VIEW',
                                        ['ROLE_MANAGE_OWN_PROFILE'],
                                        this.handleLogoutUser,
                                        'profile.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'profile'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/my-delegation-list'
                                    component={withAuth(
                                        DelegationTabContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_OWN_DELEGATION'],
                                        this.handleLogoutUser,
                                        'delegation.myDelegationlistName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'my-delegation-list',
                                    )}
                                />
                                <Route
                                    exact
                                    path='/my-delegation/details/:id'
                                    component={withAuth(
                                        DelegationContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_OWN_DELEGATION'],
                                        this.handleLogoutUser,
                                        'delegation.myDelegationlistName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation',
                                        undefined,
                                        {
                                            backUrl:"/#/my-delegation-list",
                                            cancelUrl:"/#/my-delegation/details",
                                            editUrl:"/#/my-delegation/edit"
                                        }
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/my-delegation/create'
                                    component={withAuth(
                                        DelegationContainer,
                                        'NEW',
                                        ['ROLE_REPORT_OWN_DELEGATION'],
                                        this.handleLogoutUser,
                                        'delegation.myDelegationlistName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation',
                                        undefined,
                                        {
                                            backUrl:"/#/my-delegation-list",
                                            cancelUrl:"/#/my-delegation/details",
                                            editUrl:"/#/my-delegation/edit"
                                        }
                                    )}
                                />
                                <Route
                                    exact
                                    path='/my-delegation/edit/:id'
                                    component={withAuth(
                                        DelegationContainer,
                                        'EDIT',
                                        ['ROLE_REPORT_OWN_DELEGATION'],
                                        this.handleLogoutUser,
                                        'delegation.myDelegationlistName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation',
                                        undefined,
                                        {
                                            backUrl:"/#/my-delegation-list",
                                            cancelUrl:"/#/my-delegation/details",
                                            editUrl:"/#/my-delegation/edit"
                                        }

                                    )}
                                />
                                <Route
                                    exact
                                    path='/delegation-list'
                                    component={withAuth(
                                        DelegationListContainer,
                                        'VIEW',
                                        ['ROLE_DELEGATION_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'delegation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation-list',
                                    )}
                                />
                                <Route
                                    exact
                                    path='/delegation/details/:id'
                                    component={withAuth(
                                        DelegationContainer,
                                        'VIEW',
                                        ['ROLE_DELEGATION_VIEW'],
                                        this.handleLogoutUser,
                                        'delegation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/delegation/create'
                                    component={withAuth(
                                        DelegationContainer,
                                        'NEW',
                                        ['ROLE_DELEGATION_EDIT'],
                                        this.handleLogoutUser,
                                        'delegation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/delegation/edit/:id'
                                    component={withAuth(
                                        DelegationContainer,
                                        'EDIT',
                                        ['ROLE_DELEGATION_EDIT'],
                                        this.handleLogoutUser,
                                        'delegation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'delegation'
                                    )}
                                />

                                {authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/user/details/:id'
                                        component={withAuth(
                                            InternalUserContainer,
                                            'VIEW',
                                            ['ROLE_USER_VIEW', 'ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'internaluser.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'user'
                                        )}
                                    /> : null}
                                {authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/user/edit/:id'
                                        component={withAuth(
                                            InternalUserContainer,
                                            'EDIT',
                                            ['ROLE_USER_VIEW'],
                                            this.handleLogoutUser,
                                            'internaluser.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'user'
                                        )}
                                    /> : null}
                                {authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/user/create'
                                        component={withAuth(
                                            InternalUserContainer,
                                            'NEW',
                                            ['ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'internaluser.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'user'
                                        )}
                                    /> : null}
                                {this.authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/employee-list'
                                        component={withAuth(
                                            EmployeeListContainer,
                                            'VIEW',
                                            ['ROLE_USER_LIST_VIEW'],
                                            this.handleLogoutUser,
                                            'employee.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    />
                                    :
                                    null
                                }

                                {this.authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/employee/create'
                                        component={withAuth(
                                            EmployeeContainer,
                                            'NEW',
                                            ['ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'employee.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    />
                                    :
                                    null}
                                {this.authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/employee/details/:id'
                                        component={withAuth(
                                            EmployeeContainer,
                                            'VIEW',
                                            ['ROLE_USER_VIEW'],
                                            this.handleLogoutUser,
                                            'employee.details.header',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    />
                                    :
                                    null}
                                {this.authService.getProfile().usersViewMode === 'SEPARATE' ?
                                    <Route
                                        exact
                                        path='/employee/edit/:id'
                                        component={withAuth(
                                            EmployeeContainer,
                                            'EDIT',
                                            ['ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'employee.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    />
                                    :
                                    null}
                                {this.authService.getProfile().usersViewMode === 'ALL' ?
                                    <Route
                                        exact
                                        path='/user/create'
                                        component={withAuth(
                                            UserDetailsContainer,
                                            'NEW',
                                            ['ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'global.empty',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    /> : null}
                                {this.authService.getProfile().usersViewMode === 'ALL' ?
                                    <Route
                                        exact
                                        path='/user/details/:id'
                                        component={withAuth(
                                            UserDetailsContainer,
                                            'VIEW',
                                            ['ROLE_USER_VIEW'],
                                            this.handleLogoutUser,
                                            'global.empty',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee',
                                        )}
                                    /> : null}
                                {this.authService.getProfile().usersViewMode === 'ALL' ?
                                    <Route
                                        exact
                                        path='/user/edit/:id'
                                        component={withAuth(
                                            UserDetailsContainer,
                                            'EDIT',
                                            ['ROLE_USER_EDIT'],
                                            this.handleLogoutUser,
                                            'global.empty',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'employee'
                                        )}
                                    /> : null}



                                    <Route
                                    exact
                                    path='/employee-leave-request-list'
                                    component={withAuth(
                                        LeaveRequestListContainer,
                                        'VIEW',
                                        ['ROLE_LEAVE_REQUEST_MANAGE_LIST'],
                                        this.handleLogoutUser,
                                        'leaveRequest.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeLeaveRequest'
                                    )}
                                />
                                    <Route
                                    exact
                                    path='/employee-leave-request-view'
                                    component={withAuth(
                                        LeaveRequestViewContainer,
                                        'VIEW',
                                        ['ROLE_LEAVE_REQUEST_VIEW'],
                                        this.handleLogoutUser,
                                        'leaveRequest.viewName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeLeaveRequest'
                                    )}
                                />

                                    <Route
                                    exact
                                    path='/employee-leave-request/details/:id'
                                    component={withAuth(
                                        LeaveRequestContainer,
                                        'VIEW',
                                        ['ROLE_LEAVE_REQUEST_MANAGE_VIEW', 'ROLE_LEAVE_REQUEST_VIEW'],
                                        this.handleLogoutUser,
                                        'leaveRequest.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeLeaveRequest'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/employee-leave-request/create'
                                    component={withAuth(
                                        LeaveRequestContainer,
                                        'NEW',
                                        ['ROLE_LEAVE_REQUEST_EDIT'],
                                        this.handleLogoutUser,
                                        'leaveRequest.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeLeaveRequest'
                                    )}
                                />
                                       <Route
                                    exact
                                    path='/employee-leave-request/edit/:id'
                                    component={withAuth(
                                        LeaveRequestContainer,
                                        'EDIT',
                                        ['ROLE_LEAVE_REQUEST_MANAGE_EDIT', 'ROLE_LEAVE_REQUEST_VIEW'],
                                        this.handleLogoutUser,
                                        'leaveRequest.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeLeaveRequest'
                                    )}
                                />


                                <Route
                                    exact
                                    path='/help-page'
                                    component={withAuth(
                                        HelpContainer,
                                        'VIEW',
                                        ['ROLE_LOGIN_PORTAL'],
                                        this.handleLogoutUser
                                    )}
                                />
                                <Route
                                    exact
                                    path='/client-list'
                                    component={withAuth(
                                        ClientListContainer,
                                        'VIEW',
                                        ['ROLE_CLIENT_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'client.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'client'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/client/create'
                                    component={withAuth(
                                        ClientContainer,
                                        'NEW',
                                        ['ROLE_CLIENT_EDIT'],
                                        this.handleLogoutUser,
                                        'client.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'client'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/client/details/:id'
                                    component={withAuth(
                                        ClientContainer,
                                        'VIEW',
                                        ['ROLE_CLIENT_VIEW'],
                                        this.handleLogoutUser,
                                        'client.details.header.details',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'client'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/client/edit/:id'
                                    component={withAuth(
                                        ClientContainer,
                                        'EDIT',
                                        ['ROLE_CLIENT_EDIT'],
                                        this.handleLogoutUser,
                                        'client.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'client'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project/details/:id'
                                    component={withAuth(
                                        ProjectDetailsContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_VIEW'],
                                        this.handleLogoutUser,
                                        'project.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectDetails'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project/edit/:id'
                                    component={withAuth(
                                        ProjectDetailsContainer,
                                        'EDIT',
                                        ['ROLE_PROJECT_EDIT'],
                                        this.handleLogoutUser,
                                        'project.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectDetails'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project/create'
                                    component={withAuth(
                                        ProjectDetailsContainer,
                                        'NEW',
                                        ['ROLE_PROJECT_EDIT'],
                                        this.handleLogoutUser,
                                        'project.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectDetails'
                                    )}
                                />
                                   <Route
                                    exact
                                    path='/project/create/:id'
                                    component={withAuth(
                                        ProjectDetailsContainer,
                                        'NEW',
                                        ['ROLE_PROJECT_EDIT'],
                                        this.handleLogoutUser,
                                        'project.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectDetails'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/settings-list'
                                    component={withAuth(
                                        ApplicationSettingsListContainer,
                                        'VIEW',
                                        ['ROLE_PARAM_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'settings.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'settings'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/eventlog-list'
                                    component={withAuth(
                                        LogEntryListContainer,
                                        'VIEW',
                                        ['ROLE_EVENT_LOG_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'logEntry.list.title',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'logEntries'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/dashboard'
                                    component={withAuth(
                                        DashboardContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_VIEW', 'ROLE_PROJECT_LIST_VIEW', 'ROLE_ACCOMMODATION_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'Dashboard',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'dashboard'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/subcontractor-list'
                                    component={withAuth(
                                        SubcontratorListContainer,
                                        'VIEW',
                                        ['ROLE_SUBCONTRACTOR_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'subcontractor.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'subcontractor'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/projectcategory-list'
                                    component={withAuth(
                                        ProjectCategoryListContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_CATEGORY_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'projectCategory.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectCategory'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/after-hours-drive-alarm-list'
                                    component={withAuth(
                                        AfterHoursDriveAlarmListContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_DRIVE_AFTER_HOUR'],
                                        this.handleLogoutUser,
                                        'afterHoursDriveAlarm.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'afterHoursDriveAlarm'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project-daily-overview'
                                    component={withAuth(
                                        ProjectDailyOverviewListContainer,
                                        'VIEW',
                                        ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SUPERVISOR', 'ROLE_CTO'],
                                        this.handleLogoutUser,
                                        'projectDailyOverview.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        'afterHoursDriveAlarm'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/hourlyreport-list'
                                    component={withAuth(
                                        HourlyReportListContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_USER_TIME'],
                                        this.handleLogoutUser,
                                        'hourlyreport.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'hourlyReport'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/payroll-entry-list'
                                    component={withAuth(
                                        PayrollEntryListContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_USER_TIME'],
                                        this.handleLogoutUser,
                                        'payrollEntry.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'payrollEntry'
                                    )}
                                />
                                {this.authService.getProfile().userContractPriceStrategy === Constants.NONE ?
                                    null :
                                    <Route
                                        exact
                                        path='/pay-report'
                                        component={withAuth(
                                            PayReportListContainer,
                                            'VIEW',
                                            ['ROLE_REPORT_PAYOUT'],
                                            this.handleLogoutUser,
                                            'payReport.listName',
                                            undefined,
                                            undefined,
                                            false,
                                            this.handleShowMenu,
                                            this.setActiveMenu,
                                            this.updateApp,
                                            'payReport'
                                        )}
                                    />
                                    }
                                <Route
                                    exact
                                    path='/project-report-cumulative'
                                    component={withAuth(
                                        ProjectCumulativeReportListContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_PROJECTS_CUMULATIVE'],
                                        this.handleLogoutUser,
                                        'projectCumulativeReport.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectCumulativeReport'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/activity-list'
                                    component={withAuth(
                                        ActivityListContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_ACTIVITY_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'activity.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'activity'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/car-list'
                                    component={withAuth(
                                        CarListContainer,
                                        'VIEW',
                                        ['ROLE_CAR_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'car.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'car'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tools-list'
                                    component={withAuth(
                                        ToolsListContainer,
                                        'VIEW',
                                        ['ROLE_TOOLBOX_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'tools.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tools'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tools/details/:id'
                                    component={withAuth(
                                        ToolsDetailsContainer,
                                        'VIEW',
                                        ['ROLE_TOOLBOX_VIEW'],
                                        this.handleLogoutUser,
                                        'tools.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tools'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tools/edit/:id'
                                    component={withAuth(
                                        ToolsDetailsContainer,
                                        'EDIT',
                                        ['ROLE_TOOLBOX_EDIT'],
                                        this.handleLogoutUser,
                                        'tools.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tools'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/tools/create'
                                    component={withAuth(
                                        ToolsDetailsContainer,
                                        'NEW',
                                        ['ROLE_TOOLBOX_EDIT'],
                                        this.handleLogoutUser,
                                        'tools.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tools'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tool-list'
                                    component={withAuth(
                                        ToolListContainer,
                                        'VIEW',
                                        ['ROLE_TOOLBOX_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'tool.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tool'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tool/details/:id'
                                    component={withAuth(
                                        ToolDetailsContainer,
                                        'VIEW',
                                        ['ROLE_TOOL_VIEW'],
                                        this.handleLogoutUser,
                                        'tool.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tool'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tool/create'
                                    component={withAuth(
                                        ToolDetailsContainer,
                                        'NEW',
                                        ['ROLE_TOOL_EDIT'],
                                        this.handleLogoutUser,
                                        'tool.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tool'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/tool/delete/:id'
                                    component={withAuth(
                                        ToolDetailsContainer,
                                        'DELETE',
                                        ['ROLE_TOOL_EDIT'],
                                        this.handleLogoutUser,
                                        'tool.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tool'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/tool/edit/:id'
                                    component={withAuth(
                                        ToolDetailsContainer,
                                        'EDIT',
                                        ['ROLE_TOOL_EDIT'],
                                        this.handleLogoutUser,
                                        'tool.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'tool'
                                    )}
                                />

                                <Route
                                    path='/project-dashboard-fullscreen'
                                    render={(props) => (
                                        <ProjectDashboardFullScreenContainer
                                            handleHideMenu={this.handleHideMenu}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project-dashboard'
                                    component={withAuth(
                                        ProjectDashboardContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_DASHBOARD_VIEW'],
                                        this.handleLogoutUser,
                                        'project.dashboardName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'project-d'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project-list'
                                    component={withAuth(
                                        ProjectListContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'project.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'project'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project/plan/managers'
                                    component={withAuth(
                                        ManagerTimelineContainer,
                                        'VIEW',
                                        ['ROLE_PROJECT_LEADER_PLANING_VIEW'],
                                        this.handleLogoutUser,
                                        'project.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'project'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/driver-rate-list'
                                    component={withAuth(
                                        DriverRateListContainer,
                                        'VIEW',
                                        ['ROLE_USER_ABSENCE_REASON_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'driver-rate.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'car'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reported-day-list'
                                    component={withAuth(
                                        ReportedDayListContainer,
                                        'VIEW',
                                        ['ROLE_TIMESHEET_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'reportedDay.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDay'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reported-day/details/:id'
                                    component={withAuth(
                                        ReportedDayDetailsContainer,
                                        'VIEW',
                                        ['ROLE_TIMESHEET_VIEW'],
                                        this.handleLogoutUser,
                                        'reportedDay.details',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayDetails'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reported-day/edit/:id'
                                    component={withAuth(
                                        ReportedDayDetailsContainer,
                                        'EDIT',
                                        ['ROLE_TIMESHEET_EDIT'],
                                        this.handleLogoutUser,
                                        'reportedDay.details',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayDetails'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/user-day/details/:id'
                                    component={withAuth(
                                        UserDayDetailsContainer,
                                        'VIEW',
                                        ['ROLE_TIMESHEET_VIEW'],
                                        this.handleLogoutUser,
                                        'reportedDay.details',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayDetails'
                                    )}
                                />
                                  <Route
                                    exact
                                    path='/user-day/edit/:id'
                                    component={withAuth(
                                        UserDayDetailsContainer,
                                        'EDIT',
                                        ['ROLE_TIMESHEET_VIEW'],
                                        this.handleLogoutUser,
                                        'reportedDay.details',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayDetails'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/user-day/create'
                                    component={withAuth(
                                        UserDayCreateContainer,
                                        'NEW',
                                        ['ROLE_TIMESHEET_APPROVE'],
                                        this.handleLogoutUser,
                                        'reportedDay.create',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayDetails'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reported-day/create'
                                    component={withAuth(
                                        ReportedDayDetailsContainer,
                                        'NEW',
                                        ['ROLE_TIMESHEET_EDIT'],
                                        this.handleLogoutUser,
                                        'reportedDay.new',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reportedDayNew'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/email-list'
                                    component={withAuth(
                                        EmailListContainer,
                                        'VIEW',
                                        ['ROLE_DICT_EMAIL_TEMPLATE_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'email.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'emailList'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/email/edit/:id'
                                    component={withAuth(
                                        EmailEditContainer,
                                        'EDIT',
                                        ['ROLE_DICT_EMAIL_TEMPLATE_EDIT'],
                                        this.handleLogoutUser,
                                        'email.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'emailEdit'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/email/details/:id'
                                    component={withAuth(
                                        EmailEditContainer,
                                        'VIEW',
                                        ['ROLE_DICT_EMAIL_TEMPLATE_VIEW'],
                                        this.handleLogoutUser,
                                        'email.detailsHeader',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'emailEdit'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/project-report-settle'
                                    component={withAuth(
                                        ProjectSettleReportListContainer,
                                        'VIEW',
                                        ['ROLE_REPORT_PROJECTS_SETTLE'],
                                        this.handleLogoutUser,
                                        'projectSettleReport.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'projectSettleReport'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/document-types-list'
                                    component={withAuth(
                                        DocumentTypeListContainer,
                                        'VIEW',
                                        ['ROLE_USER_DOCUMENT_TYPE_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'documentType.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'documentTypes'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/employee-absence-reason-list'
                                    component={withAuth(
                                        EmployeeAbsenceReasonList,
                                        'VIEW',
                                        ['ROLE_USER_ABSENCE_REASON_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'employee.absence.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeAbsenceList'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/employeecategory-list'
                                    component={withAuth(
                                        UserCategoryListContainer,
                                        'VIEW',
                                        ['ROLE_USER_CATEGORY_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'employeeCategory.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employeeCategory'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reserve'
                                    component={withAuth(
                                        ReserveContainer,
                                        'VIEW',
                                        ['ROLE_USER_RESERVE_VIEW'],
                                        this.handleLogoutUser,
                                        'reserve.label',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'reserveEmployeesContainer'
                                    )}
                                />
                                <Route
                                    exact
                                    path='/reserve/employee/edit/:id'
                                    component={withAuth(
                                        this.authService.getProfile().usersViewMode === 'ALL' ? UserDetailsContainer : EmployeeContainer,
                                        'EDIT',
                                        ['ROLE_USER_RESERVE_EDIT'],
                                        this.handleLogoutUser,
                                        this.authService.getProfile().usersViewMode === 'ALL' ? 'global.empty' : 'employee.details.header',
                                        undefined,
                                        '#/reserve',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employee',
                                        undefined,
                                        {cancelUrl: '#/reserve/employee/details'}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/country-list'
                                    component={withAuth(
                                        CountryListContainer,
                                        'VIEW',
                                        ['ROLE_DICT_COUNTRY_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'country.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'country'
                                    )}
                                />
                                   <Route
                                    exact
                                    path='/public-holidays-calendar'
                                    component={withAuth(
                                        PublicHolidaysCalendarComponent,
                                        'VIEW',
                                        ['ROLE_PUBLIC_HOLIDAYS_VIEW'],
                                        this.handleLogoutUser,
                                        'public-holidays.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'country'
                                    )}
                                />

                                <Route
                                    exact
                                    path='/reserve/employee/details/:id'
                                    component={withAuth(
                                        this.authService.getProfile().usersViewMode === 'ALL' ? UserDetailsContainer : EmployeeContainer,
                                        'VIEW',
                                        ['ROLE_USER_RESERVE_VIEW'],
                                        this.handleLogoutUser,
                                        this.authService.getProfile().usersViewMode === 'ALL' ? 'global.empty' : 'employee.details.header',
                                        undefined,
                                        '#/reserve',
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'employee',
                                        undefined,
                                        {editUrl: '#/reserve/employee/edit'}
                                    )}
                                />
                                <Route
                                    exact
                                    path='/external-supervisor/list'
                                    component={withAuth(
                                        ExternalSupervisorList,
                                        'VIEW',
                                        ['ROLE_PROJECT_EXTERNAL_SUPERVISOR_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'externalSupervisor.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'external-supervisor'
                                    )}
                                />
                               <Route
                                    exact
                                    path='/accommodation-list'
                                    component={withAuth(
                                        AccommodationListContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'accommodation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                  <Route
                                    exact
                                    path='/accommodation/create'
                                    component={withAuth(
                                        AccommodationContainer,
                                        'NEW',
                                        ['ROLE_ACCOMMODATION_EDIT'],
                                        this.handleLogoutUser,
                                        'accommodation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/accommodation/details/:id'
                                    component={withAuth(
                                        AccommodationContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_VIEW'],
                                        this.handleLogoutUser,
                                        'accommodation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/accommodation/edit/:id'
                                    component={withAuth(
                                        AccommodationContainer,
                                        'EDIT',
                                        ['ROLE_ACCOMMODATION_EDIT'],
                                        this.handleLogoutUser,
                                        'accommodation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                             <Route
                                    exact
                                    path='/accommodation-timeline'
                                    component={withAuth(
                                        AccommodationTimelineContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_PLANING_VIEW'],
                                        this.handleLogoutUser,
                                        'timeline-accommodation.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                      <Route
                                    exact
                                    path='/accommodation-employee-timeline'
                                    component={withAuth(
                                        EmployeeAccommodationTimelineContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_PLANING_VIEW'],
                                        this.handleLogoutUser,
                                        'timeline-employees.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                 <Route
                                    exact
                                    path='/accommodation-category'
                                    component={withAuth(
                                        AccommodationCategoryContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_CATEGORY_LIST_VIEW'],
                                        this.handleLogoutUser,
                                        'accommodation.category.listName',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                  <Route
                                    exact
                                    path='/accommodation-dashboard'
                                    component={withAuth(
                                        AccommodationDashboardContainer,
                                        'VIEW',
                                        ['ROLE_ACCOMMODATION_DASHBOARD_VIEW'],
                                        this.handleLogoutUser,
                                        'accommodation.dashboard',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        'accommodation'
                                    )}
                                />
                                <Route
                                    path='/acommodation-dashboard-fullscreen'
                                    render={(props) => (
                                        <AcommodationDashboardFullScreenContainer
                                            handleHideMenu={this.handleHideMenu}
                                        />
                                    )}
                                />
                                <Route exact path='/cookies-page' component={CookiesContainer} />

                                <Route path='/version' render={(props) => <VersionContainer handleHideMenu={this.handleHideMenu} />} />
                                {!!authService.loggedIn() && authService.getProfile().allowMyTimeInPortal ? (
                                    <>
                                        <Route
                                            exact
                                            path='/day-view'
                                            component={withAuth(
                                                DayViewContainer,
                                                'VIEW',
                                                ['ROLE_REPORT_OWN_TIME'],
                                                this.handleLogoutUser,
                                                'Raportowanie czasu',
                                                undefined,
                                                undefined,
                                                false,
                                                this.handleShowMenu,
                                                this.setActiveMenu,
                                                this.updateApp,
                                                'day-view'
                                            )}
                                        />
                                        <Route
                                            exact
                                            path='/week-view'
                                            component={withAuth(
                                                WeekViewContainer,
                                                'VIEW',
                                                ['ROLE_REPORT_OWN_TIME'],
                                                this.handleLogoutUser,
                                                'Raportowanie czasu',
                                                undefined,
                                                undefined,
                                                false,
                                                this.handleShowMenu,
                                                this.setActiveMenu,
                                                this.updateApp,
                                                'week-view'
                                            )}
                                        />
                                        <Route
                                            exact
                                            path='/month-view'
                                            component={withAuth(
                                                MonthViewContainer,
                                                'VIEW',
                                                ['ROLE_REPORT_OWN_TIME'],
                                                this.handleLogoutUser,
                                                'Raportowanie czasu',
                                                undefined,
                                                undefined,
                                                false,
                                                this.handleShowMenu,
                                                this.setActiveMenu,
                                                this.updateApp,
                                                'month-view'
                                            )}
                                        />
                                    </>
                                ) : null}


                              <Route
                                    //redirect do login page jesli user jest niezalogowany
                                    //ten Route musi być na końcu
                                    exact
                                    path='*'
                                    component={withAuth(
                                        () => (
                                            <div>
                                            </div>
                                        ),
                                        'VIEW',
                                        [''],
                                        this.handleLogoutUser,
                                        '',
                                        undefined,
                                        undefined,
                                        false,
                                        this.handleShowMenu,
                                        this.setActiveMenu,
                                        this.updateApp,
                                        ''
                                    )}
                                />
                            </Switch>
                        </main>
                    </div>
                </Router>
            </React.Fragment>
        );
    }
}

export default withTranslation()(App);
